import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { Col, Row, Card, Container, Breadcrumb, Table, Badge, Form } from 'react-bootstrap';
import { TabView, TabPanel } from 'primereact/tabview';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import { DateRangePicker } from "react-bootstrap-daterangepicker";
import moment from "moment";
import { Button } from 'primereact/button';
import { Image } from 'primereact/image';
import { Sidebar } from 'primereact/sidebar';
import { InputNumber } from 'primereact/inputnumber';
import { Calendar } from 'primereact/calendar';
import { RadioButton } from "primereact/radiobutton";
import { useAuth } from '../../context/AuthContext';
import axios from 'axios';
import config from '../../config';
import nouserImg from '../../assets/images/no_user.png';
import CustomConfirmPopup from "../../components/CustomConfirmPopup";
import AddLeadForm from "../../modalPopup/AddLeadForm";
import EditLeadform from "../../modalPopup/EditLeadform";


const Client_lead = () => {
    const { accessToken, userId } = useAuth();
    const [leads, setLeads] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedLead, setSelectedLead] = useState(null);
    const [showConfirm, setShowConfirm] = useState(false);
    const [visibleRight, setVisibleRight] = useState(false);
    const [editVisible, setEditVisible] = useState(false);
    const [expandedRows, setExpandedRows] = useState({});
    const [visibleRight2, setVisibleRight2] = useState(false);
    const toggleExpand = (id) => {
        setExpandedRows((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));
    };


    // ✅ Fetch leads for logged-in user
    const fetchLeads = async () => {
        try {
            setLoading(true);
            const res = await axios.get(`${config.apiBASEURL}/Client_LeadRoutes/specificuserlead/${userId}`, {
                headers: { Authorization: `Bearer ${accessToken}` },
            });

            if (res.status === 200 && res.data.leads) {
                setLeads(res.data.leads);
            } else {
                setLeads([]);
            }
        } catch (error) {
            console.error("Error fetching leads:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (userId && accessToken) {
            fetchLeads();
        }
    }, [userId, accessToken]);


    // ✅ Badge color mapping for multiple statuses
    const getBadgeVariant = (status) => {
        switch (status) {
            case "Draft": return "secondary";
            case "Sent": return "info";
            case "Contacted": return "primary";
            case "Converted": return "success";
            case "Closed": return "dark";
            case "Cancelled": return "danger";
            default: return "light";
        }
    };



    // ✅ Delete lead
    const handleDelete = async (leadId) => {
        try {
            await axios.delete(`${config.apiBASEURL}/Client_LeadRoutes/deleteclientlead/${leadId}`, {
                headers: { Authorization: `Bearer ${accessToken}` },
            });
            fetchLeads();
        } catch (error) {
            console.error("Error deleting lead:", error);
        }
    };


    // ✅ Send lead (change from Draft → Sent)
    const handleSendLead = async (leadId) => {
        if (!leadId) {
            return;
        }
        try {
            setLoading(true);

            const response = await axios.put(
                `${config.apiBASEURL}/Client_LeadRoutes/sendlead/${leadId}`,
                {}, // no payload required
                { headers: { Authorization: `Bearer ${accessToken}` } }
            );

            // ✅ Show success message
            if (response.status === 200) {
                fetchLeads(); // Refresh the lead list
            } else {
                alert("Unexpected response from server.");
            }
        } catch (error) {
            console.error("Error sending lead:", error);
            if (error.response) {
                // ✅ Show detailed backend error messages
                const backendError = error.response.data?.error || "Failed to send lead.";
                alert(`Error: ${backendError}`);
            } else {
                alert("Network error. Please try again.");
            }
        } finally {
            setLoading(false);
        }
    };


    // ✅ Open edit sidebar with selected lead data
    const handleEditLead = (lead) => {
        setSelectedLead(lead);
        setEditVisible(true);
    };

    const handleleadviewClick = (lead) => {
        setSelectedLead(lead);
        setVisibleRight2(true);
    }
    return (
        <>
            <Row className="body_content">
                <Row className="mx-0">
                    <Col sm={12} xs={12} className="mb-4 d-lg-flex justify-content-between align-items-center">
                        <Breadcrumb>
                            <Breadcrumb.Item active>Referrals</Breadcrumb.Item>
                        </Breadcrumb>
                        <div className="d-flex justify-content-end mt-3 mt-lg-0">
                            {/* <DateRangePicker
                                initialSettings={{
                                    startDate: dateRange.startDate,
                                    endDate: dateRange.endDate,
                                    locale: { format: "DD/MM/YYYY" },
                                    ranges: {
                                        Today: [moment(), moment()],
                                        Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
                                        "Last 7 Days": [moment().subtract(6, "days"), moment()],
                                        "Last 30 Days": [moment().subtract(29, "days"), moment()],
                                        "This Month": [moment().startOf("month"), moment().endOf("month")],
                                        "Last Month": [
                                            moment().subtract(1, "month").startOf("month"),
                                            moment().subtract(1, "month").endOf("month"),
                                        ],
                                    },
                                }}
                                onCallback={(start, end) => handleDateRangeChange(start, end)}
                            >
                                <input
                                    type="text"
                                    className="form-control mx-2"
                                    style={{ width: "200px" }}
                                    placeholder="Select Date Range"
                                />
                            </DateRangePicker> */}
                            <Button
                                label="Refferel"
                                icon="pi pi-plus"
                                className="border-0 py-2"
                                severity="help"
                                onClick={() => setVisibleRight(true)}
                            />
                        </div>

                    </Col>
                    <Col lg={12}>

                        <Card className="shadow-sm p-3">
                            {loading ? (
                                <p>Loading Referrals...</p>
                            ) : leads.length === 0 ? (
                                <p>No Referrals found.</p>
                            ) : (
                                <Table size="sm" bordered hover responsive>
                                    <thead className="table-light">
                                        <tr className="table-primary">

                                            <th>Referral Info</th>
                                            <th>Contact Details</th>
                                            <th style={{ width: '470px' }}>Requirement</th>
                                            <th style={{ width: '100px', textAlign: 'center' }}>Status</th>
                                            <th style={{ width: '190px' }}>Submitted by</th>
                                            <th style={{ width: '170px' }}>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {leads.map((lead) => (
                                            <tr key={lead.client_lead_id}>

                                                <td>
                                                    <span className="d-block border-bottom pb-2 mb-2">
                                                        <b>POC : </b>{lead.lead_name || "N/A"}
                                                    </span>
                                                    <span>
                                                        <b>Lead Type :</b> {lead.lead_type || "N/A"}
                                                    </span>

                                                </td>
                                                <td >
                                                    <span className="d-block border-bottom pb-2 mb-2">
                                                        <i className="pi pi-phone text-warning" style={{ fontSize: "13px", verticalAlign: "middle" }}></i> {lead.email || "N/A"}
                                                    </span>
                                                    <span>
                                                        <i className="pi pi-envelope text-info" style={{ fontSize: "13px", verticalAlign: "middle" }}></i> {lead.phone_no || "N/A"}
                                                    </span>
                                                </td>
                                                {/* <td>{lead.requirement || "N/A"}</td> */}
                                                <td>
                                                    <div style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}>
                                                        {(expandedRows[lead.id] ? lead.requirement : lead.requirement?.slice(0, 80)) || "N/A"}
                                                        {lead.requirement && lead.requirement.length > 80 && (
                                                            <button
                                                                onClick={() => toggleExpand(lead.id)}
                                                                style={{
                                                                    border: "none",
                                                                    background: "none",
                                                                    color: "#007bff",
                                                                    cursor: "pointer",
                                                                    padding: 0,
                                                                    marginLeft: "5px",
                                                                }}
                                                            >
                                                                {expandedRows[lead.id] ? "Less..." : "More..."}
                                                            </button>
                                                        )}
                                                    </div>
                                                </td>
                                                <td className="text-center">
                                                    <Badge bg={getBadgeVariant(lead.status)}>
                                                        {lead.status}
                                                    </Badge>
                                                </td>
                                                <td>
                                                    <div className="d-flex align-items-center gap-2">
                                                        <Image
                                                            src={
                                                                lead?.leadOwner?.profileImage?.image_url
                                                                    ? lead.leadOwner.profileImage.image_url
                                                                    : nouserImg
                                                            }
                                                            alt="Profile"
                                                            width="50"
                                                            height="50"
                                                            style={{
                                                                objectFit: "cover",
                                                                borderRadius: "50%",
                                                            }}
                                                        />
                                                        <span>{lead?.leadOwner?.first_name || "Unknown"} {lead?.leadOwner?.last_name || "Unknown"}</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <Button
                                                        icon="pi pi-eye"
                                                        className="p-button-rounded p-button-info p-button-sm me-2 p-0"
                                                        tooltip="View Lead"
                                                        text
                                                        onClick={() => handleleadviewClick(lead)}
                                                    />
                                                    {lead.status === "Draft" ? (
                                                        <>

                                                            <Button
                                                                icon="pi pi-send"
                                                                className="p-button-rounded p-button-info p-button-sm me-2 p-0"
                                                                tooltip="Send Lead"
                                                                text
                                                                onClick={() => handleSendLead(lead.Client_lead_id)}
                                                            />
                                                            <Button
                                                                icon="pi pi-pencil"
                                                                className="p-button-rounded p-button-warning p-button-sm me-2 p-0"
                                                                tooltip="Edit Lead"
                                                                text
                                                                onClick={() => handleEditLead(lead)} // ✅ Pass selected lead
                                                            />
                                                            {/* <Button
                                                                icon="pi pi-trash"
                                                                className="p-button-rounded p-button-danger p-button-sm"
                                                                tooltip="Delete Lead"
                                                                onClick={() => {
                                                                    handleDelete(lead.Client_lead_id);
                                                                }}
                                                            /> */}
                                                            <CustomConfirmPopup
                                                                message="Are you sure you want to delete this Referral?"
                                                                icon="pi pi-exclamation-triangle"
                                                                defaultFocus="accept"
                                                                acceptClassName="p-button-danger"
                                                                buttonLabel="Delete"
                                                                title="Delete Referral"
                                                                buttonClass="p-button-danger p-button-text"
                                                                className="border-0 p-0"
                                                                buttonIcon="pi pi-trash"
                                                                onConfirm={() => handleDelete(lead.Client_lead_id)}
                                                                onReject={() => console.log('Delete action cancelled')}
                                                            />
                                                        </>
                                                    ) : null}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            )}
                        </Card>

                    </Col>
                </Row>
            </Row>
            <Sidebar
                visible={visibleRight}
                position="right"
                onHide={() => setVisibleRight(false)}
                dismissable={false}
                style={{ width: '450px' }}
            >
                <AddLeadForm
                    onClose={() => setVisibleRight(false)}
                    onLeadAdded={fetchLeads}
                />
            </Sidebar>

            <Sidebar
                visible={editVisible}
                position="right"
                onHide={() => {
                    setEditVisible(false);
                    setSelectedLead(null); // ✅ Clear selected lead when sidebar closes
                }}
                style={{ width: '450px' }}
                dismissable={false}
            >
                {selectedLead && (
                    <EditLeadform
                        leadData={selectedLead} // ✅ Send selected lead as prop
                        onClose={() => {
                            setEditVisible(false);
                            setSelectedLead(null); // ✅ Also clear when form manually closes
                        }}
                        onLeadUpdated={fetchLeads}
                    />
                )}
            </Sidebar>

            <Sidebar visible={visibleRight2} position="right"
                onHide={() => {
                    setVisibleRight2(false);
                    setSelectedLead(null); // ✅ Clear selected lead when sidebar closes
                }}
                style={{ width: '40vw' }}>
                <Card className="shadow-0">
                    <Card.Header className="d-flex align-items-center justify-content-end border-0 p-0 mb-4">
                    </Card.Header>
                    <Card.Body>
                        <div className="allempList">
                            <div className="rol-title">Referral Details</div>
                            <Table borderless>
                                <thead>
                                    <tr>
                                        <th>Poc/Company Name</th>
                                        <td>{selectedLead?.lead_name || "N/A"}</td>
                                    </tr>
                                    <tr>
                                        <th>Category</th>
                                        <td>{selectedLead?.lead_type || "N/A"}</td>
                                    </tr>
                                    <tr>
                                        <th>Phone no</th>
                                        <td>{selectedLead?.phone_no || "N/A"}</td>
                                    </tr>
                                    <tr>
                                        <th>Email</th>
                                        <td>{selectedLead?.email || "N/A"}</td>
                                    </tr>
                                    <tr>
                                        <th>Requirement</th>
                                        <td>{selectedLead?.requirement || "N/A"}</td>
                                    </tr>
                                    <tr>
                                        <th>Status</th>
                                        <td>{selectedLead?.status || "N/A"}</td>
                                    </tr>
                                    <tr>
                                        <th>Submitted By</th>
                                        <td>{selectedLead?.leadOwner?.first_name || ""} {selectedLead?.leadOwner?.last_name || ""}</td>
                                    </tr>
                                </thead>
                            </Table>
                        </div>

                        <div className="allempList">
                            <div className="rol-title">On-boarding Client Details</div>
                            <Table borderless>
                                <thead>
                                    <tr>
                                        <th>Client Name</th>
                                        <td>{selectedLead?.client?.Billing_name || "N/A"}</td>
                                    </tr>
                                </thead>
                            </Table>
                        </div>

                        <div className="allempList">
                            <div className="rol-title">Conversion Info</div>
                            <Table borderless>
                                <thead>
                                    <tr>
                                        <th>Final Billing Amount</th>
                                        <td>{selectedLead?.final_amount || "N/A"}</td>
                                    </tr>
                                    <tr>
                                        <th>Percentage (%)</th>
                                        <td>{selectedLead?.percentage || "N/A"}%</td>
                                    </tr>
                                    <tr>
                                        <th>Commission Amount</th>
                                        <td>{selectedLead?.commission_amount || "N/A"}</td>
                                    </tr>
                                    <tr>
                                        <th>Conversion Date</th>
                                        <td> {selectedLead?.conversion_date
                                            ? new Date(selectedLead.conversion_date).toLocaleDateString('en-GB')
                                            : "N/A"}</td>
                                    </tr>
                                    <tr>
                                        <th>Payment Mode</th>
                                        <td>{selectedLead?.payment_mode || "N/A"}</td>
                                    </tr>
                                    <tr>
                                        <th>Payment Status</th>
                                        <td>{selectedLead?.payment_status || "N/A"}</td>
                                    </tr>
                                    <tr>
                                        <th>Payment Date</th>
                                        <td>{selectedLead?.payment_date
                                            ? new Date(selectedLead.payment_date).toLocaleDateString('en-GB')
                                            : "N/A"}</td>
                                    </tr>
                                </thead>
                            </Table>
                        </div>
                    </Card.Body>
                </Card>
            </Sidebar>
        </>
    );
}

export default Client_lead